export class SubmitCancelMeetingModel {
    meetingSk: string;
    reason: number;
    otherReason: string;
    constructor(data: any) {
        this.meetingSk = data?.meetingSk;
        this.reason = data?.reason?.id;
        this.otherReason = data?.otherReason;
    }
    get id(){
        return this.meetingSk;
    }
}